<div
  *ngIf="observation"
  class="ir-area ir-mask th-mask"
  [open]="!isOpen"
  [attr.data-keyboard]="true"
  [attr.data-backdrop]="false"
>
  <form class="ir-modal th-modal">
    <div class="ir-modal--title">
      <div class="ir-line">
        <div class="ir-line-content">
          <span>{{ title }}</span>
        </div>
      </div>
    </div>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-plugin-table">
          <tr>
            <td class="margin">
              <h2>
                <span>{{ 'plugins.observation.name' | translate }}</span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <textarea
                  name="observation"
                  rows="5"
                  class="ir-form-set"
                  type="text"
                  [(ngModel)]="observation.Observation"
                >
                </textarea>
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin">
              <h2>
                <span>{{ 'plugins.observation.recommandation' | translate }}</span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <textarea
                  rows="5"
                  name="recommandation"
                  class="ir-form-set"
                  type="text"
                  [(ngModel)]="observation.Recommandation"
                >
                </textarea>
              </div>
            </td>
          </tr>
          <tr class="th-plugin-line--checkbox label" (click)="updateInformAdmin()" *ngIf="observation.CanAddToTemplate">
            <td></td>
            <td>
              <i class="material-icons" *ngIf="!isInform()">check_box_outline_blank</i>
              <i class="material-icons" *ngIf="isInform()">check_box</i>
              <span>{{ 'plugins.observation.inform-administrator' | translate }}</span>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="close()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right" (click)="save()">
            <span>{{ 'common.save' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
